// In App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import TastyBites from './pages/TastyBites';
import Login from './pages/Login';
import OrderHistory from './pages/OrderHistory';
import UserProfile from './pages/UserProfile';

function App() {
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState([]); // Add cart state to App.js
  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('authToken');
  };

  // Define getTotalItems in App.js
  const getTotalItems = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  return (
    <Router>
      <div className="App">
        <Navigation 
          user={user} 
          onLogout={handleLogout}
          isCartOpen={isCartOpen}
          setIsCartOpen={setIsCartOpen}
          getTotalItems={getTotalItems}
        />
        <Routes>
          <Route 
            path="/react" 
            element={
              <TastyBites 
                cart={cart}
                setCart={setCart}
                isCartOpen={isCartOpen}
                setIsCartOpen={setIsCartOpen}
              />
            } 
          />
          <Route 
            path="/login" 
            element={<Login onLogin={handleLogin} />} 
          />
          <Route 
            path="/orders" 
            element={user ? <OrderHistory /> : <Login onLogin={handleLogin} />} 
          />
          <Route 
            path="/profile" 
            element={user ? <UserProfile /> : <Login onLogin={handleLogin} />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;